module.exports = __webpack_public_path__ + "static/media/noimage.c5732431.png";